var exports = {
  "j": "xa15a2ab7--bee73f--promos",
};

module.exports = exports;
